import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { DayName } from 'generated/graphql';
import { useState } from 'react';
import { DAYS_EXCLUDING_WEEKENDS, DAYS_INCLUDING_WEEKENDS } from './constants';

interface OutboundCardDailyProps {
  shouldIncludeWeekends: boolean;
  toggleDailyFrequencyDayStatus: (days: DayName[]) => void;
}

export const OutboundCardDaily = ({
  shouldIncludeWeekends,
  toggleDailyFrequencyDayStatus,
}: OutboundCardDailyProps) => {
  const [areWeekendsIncluded, setAreWeekendsIncluded] = useState(
    shouldIncludeWeekends,
  );

  const toggleWeekendOption = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isWeekendsSelected = event.target.checked;
    setAreWeekendsIncluded(isWeekendsSelected);
    if (isWeekendsSelected) {
      toggleDailyFrequencyDayStatus(DAYS_INCLUDING_WEEKENDS);
      return;
    }
    toggleDailyFrequencyDayStatus(DAYS_EXCLUDING_WEEKENDS);
  };

  return (
    <Box mt={1}>
      <FormControlLabel
        control={
          <Checkbox
            checked={areWeekendsIncluded}
            onChange={toggleWeekendOption}
          />
        }
        label="Include weekends (Sat, Sun)"
      />
    </Box>
  );
};
